export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/et.eb442fe6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};